import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { LogoComponent } from '../../components/logo/logo.component';

@Component({
  selector: 'app-verify-new-email',
  standalone: true,
  templateUrl: './verify-new-email.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmCardImports,
    HlmSpinnerImports,
    HlmTypographyImports,
    LogoComponent,
  ],
  providers: [provideIcons({ lucideCircleCheck, lucideTriangleAlert })],
})
export class VerifyNewEmailComponent implements OnInit {
  token: string = '';
  loading = false;
  verified = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      if (this.token) {
        this.confirmChange();
      } else {
        this.error = 'Kein Bestätigungstoken gefunden.';
      }
    });
  }

  confirmChange() {
    this.loading = true;
    this.error = '';

    this.authService.confirmEmailChange(this.token).subscribe({
      next: () => {
        this.verified = true;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.detail || 'Der Bestätigungslink ist ungültig oder abgelaufen.';
      },
    });
  }

  goToSettings() {
    this.router.navigate(['/settings'], { queryParams: { tab: 'company' } });
  }
}
